import React from 'react';
import { NotificationProvider } from '../../contexts/NotificationContext';
import AchievementNotificationProvider from '../AchievementNotificationProvider';
import ReminderInitializer from '../ReminderInitializer';
// Import directly to avoid circular dependencies
import ErrorBoundary from '../ErrorBoundary';

interface NotificationManagerProps {
  children: React.ReactNode;
}

/**
 * NotificationManager
 * 
 * A top-level component that provides all notification systems:
 * - Regular system notifications (likes, comments, etc.)
 * - Achievement notifications
 * - Goal reminders
 * 
 * This should be placed high in the component tree, ideally just inside the app's
 * main router and authentication wrapper.
 */
const NotificationManager: React.FC<NotificationManagerProps> = ({ children }) => {
  // Create a simple fallback UI for error cases
  const fallbackUI = <div style={{ display: 'none' }}></div>;

  return (
    <ErrorBoundary fallback={<>{children}</>}>
      <NotificationProvider>
        <ErrorBoundary fallback={fallbackUI}>
          <AchievementNotificationProvider>
            <>
              {/* The ReminderInitializer component handles displaying reminders */}
              <ErrorBoundary fallback={fallbackUI}>
                <ReminderInitializer />
              </ErrorBoundary>
              
              {/* Render the children inside all notification providers */}
              {children}
            </>
          </AchievementNotificationProvider>
        </ErrorBoundary>
      </NotificationProvider>
    </ErrorBoundary>
  );
};

export default NotificationManager;